<template>
	<div id="patientAccountPage">
		<div class="view-area">
			<form id="patientData" class="needs-validation was-validated" novalidate @submit="checkForm" method="post">
				<div class="container">
					<div class="card shadow-sm mt-5 border-0">
						<div class="card-body">

							<div class="alert alert-danger" v-if="errors.length">
								<b>{{ $t('PleaseVerifyFollowingErrors', {count: errors.length})}}</b>
								<ul>
									<li v-for="(error, index) in errors" v-bind:key="index">{{ error }}</li>
								</ul>
							</div>

							<div class="alert" :class="{'alert-danger': response.error, 'alert-success': ! response.error, 'alert-info' : response.loading}" v-if="response.message">{{ response.message}}</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{ $t('FullName') }}</span>
								</div>
								<input type="text" placeholder="Ex.: Maria Aparecida" class="form-control" v-if="this.$user" required disabled v-model="userData.name">
							</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{ $t('Birthdate')}}</span>
								</div>
								<input type="tel" placeholder="DD/MM/YYYY" class="form-control" v-if="this.$user" v-mask="'##/##/####'" required v-model="userData.birthdate">
							</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{ $t('Email') }}</span>
								</div>
								<input type="email" placeholder="seu@email.com.br" class="form-control" v-if="this.$user" required v-model="userData.email">
							</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{  $t('BRCPF') }}</span>
								</div>
								<input type="tel" class="form-control" v-if="this.$user" v-mask="'###.###.###-##'" required placeholder="000.000.000-00" v-model="userData.cpf">
							</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{ $t('BRRG') }}</span>
								</div>
								<input type="tel" class="form-control" placeholder="00.000.000-0" v-if="this.$user" required v-mask="'##.###.###-#'" v-model="userData.rg">
							</div>

							<div class="input-group mb-3">
								<div class="input-group-prepend">
									<span class="input-group-text">{{ $t('PhoneNumber')}}</span>
								</div>
								<input type="tel" required class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" placeholder="DDD + Número" masked="true" v-model="userData.phone">
							</div>
						</div>
						<div class="border-top p-3">
							<button class="btn btn-secondary float-right" type="submit">{{ $t('Save') }}</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import {Auth} from '@/services'

export default {
	name: "patientAccount",
	data() {
		return {
			userData: {},
			start: false,
			response: {
				error: false,
				message: null,
				loading: false,
			},
			errors: []
		};
	},
	mounted() {
		this.userData = this.$user.patient;
	},
	methods: {
		checkForm(e) {
			e.preventDefault();
				
			this.errors = [];

			if (!this.userData.name)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('FullName')}));
			if (!this.userData.phone)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('PhoneNumber')}));

			if (!this.userData.email)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('Email')}));
			else if (!this.validEmail(this.userData.email))
				this.errors.push(this.$t('InvalidField{FieldName}', {FieldName: this.$t('Email')}));

			if (!this.userData.rg)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('BRRG')}));
			if (!this.userData.cpf)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('BRCPF')}));
			if (!this.userData.birthdate)
				this.errors.push(this.$t('RequiredField{FieldName}', {FieldName: this.$t('Birthdate')}));

			if (
				this.userData.name &&
				this.userData.phone &&
				this.userData.email &&
				this.validEmail(this.userData.email) &&
				this.userData.rg &&
				this.userData.cpf &&
				this.userData.birthdate
			) {
				this.response.loading = true;
				this.response.message = this.$t('PleaseWaitSaving');
				this.updatePatient();
			}
		},
		validEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},
		updatePatient() {
			let _userData = Object.assign({}, this.userData)
			_userData.birthdate = moment(_userData.birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD');
			Auth.setUserData(_userData)
			.then(response => response.data)
			.then(data => {
				if(data.status) {
					this.response.message = this.$t('ThankYouProfileUpdated');
					this.response.error = false;
				} else {
					this.response.message = this.$t('ErrorWhileSavingTryAgain');
					this.response.error = true;
				}

				this.response.loading = false;
			})
			.catch(error => {
				this.response.loading = false;
				this.response.error = true;
				this.response.message = this.$t('ErrorWhileSavingTryAgain');

				console.error("Error[PatiendDataUpdate]", error);
			})
			
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../assets/_vars";

.input-group-text {
	min-width: 168px;

	@media screen and (max-width: $mobile) {
		min-width: 120px;
		padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/patient/patientAccountPage.vue